/**
 * Where every upgrade prompt points (docs/Decisions.md D52 item 4): the
 * "Billing and plan" section of Org settings, which starts the Stripe
 * checkout for a higher plan. The section scrolls itself into view when the
 * URL carries this hash.
 */
export const BILLING_UPGRADE_PATH = '/org/settings#billing';

/** What each tier-gated route feature is called on its upgrade page. */
export const FEATURE_NAMES = {
  forum: 'The forum',
  inbox: 'Messages',
  tasks: 'Tasks',
  videos: 'Videos',
  events: 'Events',
  calendar: 'The calendar',
  groups: 'Groups',
};
